import { createTheme, PaletteColor, PaletteColorOptions, ThemeProvider } from "@mui/material";
import { frFR } from "@mui/material/locale";
import { FunctionComponent } from "react";

//https://mui.com/customization/theming/#custom-variables
declare module "@mui/material/styles" {
  interface Palette {
    appBar: PaletteColor; // = Palette['primary']
  }

  interface PaletteOptions {
    appBar?: PaletteColorOptions; // = PaletteOptions['primary']
  }

  interface Transitions {
    default: string;
  }

  interface TransitionsOptions {
    default?: string;
  }
}

// allow <AppBar color="appBar" />
// https://stackoverflow.com/a/69264263/829728
declare module "@mui/material/AppBar" {
  interface AppBarPropsColorOverrides {
    appBar: true;
  }
}

const AppThemeProvider: FunctionComponent = ({ children }) => {
  let theme = createTheme({}, frFR);
  theme = createTheme(theme, {
    palette: {
      primary: theme.palette.augmentColor({ color: { main: "#494d4e" } }),
      secondary: theme.palette.augmentColor({ color: { main: "#bd2434" } }),
      appBar: theme.palette.augmentColor({
        color: {
          main: "#494d4e",
          contrastText: "#e1d9d0",
        },
      }),
    },
    transitions: {
      default: theme.transitions.create("all", {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.shorter,
      }),
    },
  });

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default AppThemeProvider;
